<script setup>
</script>

<template>
  <main
    class="d-flex flex-column justify-content-center align-items-center text-center"
    aria-labelledby="titre-404"
  >
    <h1 id="titre-404" class="text-danger">
      Page introuvable
    </h1>
    <img
      class="img-fluid mx-auto my-4"
      src="@/assets/error.png"
      alt=""
      aria-hidden="true"
    />
    <p class="fs-4" role="status">
      L'adresse URL demandée n'existe pas
    </p>
    <nav aria-label="Navigation de la page d'erreur">
      <router-link
        :to="{ name: 'home' }"
        class="bouton_valid btn btn-lg w-auto text-center"
      >
        Accueil
        <i class="fas fa-arrow-right" aria-hidden="true"></i>
      </router-link>
    </nav>
  </main>
</template>

<style scoped lang="scss">
@import "@/assets/main";

img {
  max-width: 40%;
  height: auto;

  @media (min-width: 768px) {
    max-width: 300px;
  }
}

.bouton_valid {
  @include boutons;

  &:hover {
    @include boutons_hover;
  }

  &:focus-visible {
    outline: 3px solid #212529;
    outline-offset: 2px;
  }
}
</style>
